import React, { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import "./App.css";
import "./i18n";
import GameErrorBoundary from "./games/GameErrorBoundary";
import Landing from "./Landing";
import { paths } from "./routes";

// Games load only when opened, so the landing page stays light.
const BrickDrop = lazy(() => import("./games/brick-drop/BrickDrop"));
const SkylineStacker = lazy(() => import("./games/skyline-stacker/SkylineStacker"));
const BrickBreaker = lazy(() => import("./games/brick-breaker/BrickBreaker"));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={paths.home} element={<Landing />} />
        <Route
          path={paths.drop}
          element={
            <GameErrorBoundary>
              <Suspense fallback={null}>
                <BrickDrop />
              </Suspense>
            </GameErrorBoundary>
          }
        />
        <Route
          path={paths.stack}
          element={
            <GameErrorBoundary>
              <Suspense fallback={null}>
                <SkylineStacker />
              </Suspense>
            </GameErrorBoundary>
          }
        />
        <Route
          path={paths.breaker}
          element={
            <GameErrorBoundary>
              <Suspense fallback={null}>
                <BrickBreaker />
              </Suspense>
            </GameErrorBoundary>
          }
        />
        <Route path="*" element={<Navigate to={paths.home} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
